import React, { useState } from "react";
import { Form, Input, Select, Button, message, Spin } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import BackRouteButton from "src/common/components/BackRouteButton";

const { Option } = Select;

export default ({ editCounteragent, profile }) => {
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const counteragent = location.state.counteragent;

  form.setFieldsValue({
    firstname: counteragent.firstname,
    lastname: counteragent.lastname,
    additionalName: counteragent.additionalName,
    phone: counteragent.phone,
    email: counteragent.email,
    firm: counteragent.firm,
    address: counteragent.address,
    comment: counteragent.comment,
    type: counteragent.type,
    profession: counteragent.profession,
  });

  const onFinish = async (values) => {
    try {
      setLoading(true);
      values._id = counteragent._id;
      values.creatorId = profile._id;
      var result = await editCounteragent(values);
      if (result.success) {
        message.success("Counteragent successfully updated!");
        history.goBack();
      }
    } catch (error) {
      message.error(result.message || "Error updating counteragent!");
      setLoading(false);
    }
  };

  return (
    <div className="common-container">
      <Spin spinning={loading}>
        <BackRouteButton />
        <h4 className="common-title--large">Edit Counteragent Information</h4>
        <Form
          requiredMark={false}
          layout="vertical"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            label="First Name"
            name="firstname"
            rules={[
              {
                required: true,
                message: "Please enter the first name!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Last Name"
            name="lastname"
            rules={[
              {
                required: true,
                message: "Please enter the last name!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Middle Name" name="additionalName">
            <Input />
          </Form.Item>

          <Form.Item
            label="Phone"
            name="phone"
            rules={[
              {
                required: true,
                message: "Please enter the phone number!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                type: "email",
                message: "Invalid email format!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Company" name="firm">
            <Input />
          </Form.Item>

          <Form.Item label="Address" name="address">
            <Input />
          </Form.Item>

          <Form.Item label="Comment" name="comment">
            <Input.TextArea />
          </Form.Item>

          <Form.Item
            label="Type"
            name="type"
            rules={[
              {
                required: true,
                message: "Please select the type of counteragent!",
              },
            ]}
          >
            <Select placeholder="Select counteragent type">
              <Option value="buyer">Buyer</Option>
              <Option value="supplier">Supplier</Option>
              <Option value="employee">Employee</Option>
              <Option value="workshop worker">Workshop Worker</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Profession" name="profession">
            <Input />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};
